import { gql } from '@apollo/client';

export default gql`
  mutation updatePreferencesPrice($input: PriceInput!) {
    updateBuyerPreferencesPrice(input: $input)
  }
`;
